import { Navigate } from "react-router-dom";
import Landing from "./Landing";

export default function Home() {
  const token = localStorage.getItem("token");

  if (token) {
    return <Navigate to="/dashboard" replace />;
  }

  return <Landing />;
}
